import React from 'react';
import type { Connection } from '../../api/types';
import PostgreSQLSetup from './PostgreSQLSetup';
import PublicWorkbookSetup from './PublicWorkbookSetup';

interface Props {
  connection: Connection;
  onSaved: (connection: Connection) => void;
  onCancel: () => void;
}

// Form dispatch is separate from database-backed capability authorization.
const editors: Record<string, React.FC<Props>> = {
  postgresql: ({ connection, onSaved, onCancel }) => (
    <PostgreSQLSetup connection={connection} onSaved={onSaved} onCancel={onCancel} onComplete={() => {}} />
  ),
  google_sheets: ({ connection, onSaved, onCancel }) => (
    <PublicWorkbookSetup connection={connection} onSaved={onSaved} onCancel={onCancel} />
  ),
  excel_online: ({ connection, onSaved, onCancel }) => (
    <PublicWorkbookSetup connection={connection} onSaved={onSaved} onCancel={onCancel} />
  ),
};

export function hasConnectionEditor(connectorId: string): boolean {
  return Object.prototype.hasOwnProperty.call(editors, connectorId);
}

export const ConnectionEditor: React.FC<Props> = props => {
  const Editor = editors[props.connection.connectorId];
  return Editor ? <Editor {...props} /> : null;
};